<template>
<div class="chapter">
<div class="inner_page">
<div>
<a id="contents_page"></a>
<a id="page_vii"></a>
<h2 class="title2">
<span class="small">CONTENTS</span>
</h2>
<p class="toc-front1" id="toc_p1">
<a href="#/intro">INTRODUCTION</a>
</p>
<p class="toc-front" id="toc_p1a">
<a href="#/prf1">PREFACE</a>
</p>
<p class="toc-chapter" id="toc_p1b">    <span href="#/chap1" title="Link target outside of Sample">I. The Ironic Element in the American Situation</span></p>
<p class="toc-chapter" id="toc_p1c">   <span href="#/chap2" title="Link target outside of Sample">II. The Innocent Nation in an Innocent World</span></p>
<p class="toc-chapter" id="toc_p1d">  <span href="#/chap3" title="Link target outside of Sample">III. Happiness, Prosperity and Virtue</span></p>
<p class="toc-chapter" id="toc_p1e">  <span href="#/chap4" title="Link target outside of Sample">IV. The Master of Destiny</span></p>
<p class="toc-chapter" id="toc_p1f">   <span href="#/chap5" title="Link target outside of Sample">V. The Triumph of Experience Over Dogma</span></p>
<p class="toc-chapter" id="toc_p1g">  <span href="#/chap6" title="Link target outside of Sample">VI. The International Class Struggle</span></p>
<p class="toc-chapter" id="toc_p1h"> <span href="#/chap7" title="Link target outside of Sample">VII. The American Future</span></p>
<p class="toc-chapter" id="toc_p1j">
<span href="#/chap8" title="Link target outside of Sample">VIII. The Significance of Irony</span>
</p>
<a id="page_viii"></a>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?2a2d6704